import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vPlayBack from 'v-playback'
import axios from '@/plugins/AxiosExtension'

Vue.use(vPlayBack);

Object.defineProperty(Vue.prototype, 'axios', { value: axios });

Array.prototype.swap = function(indexA, indexB) {
  let _arr = [...this]; let temp = _arr[indexA]; _arr[indexA] = _arr[indexB]; _arr[indexB] = temp; return _arr ;
};

window.EventBus = new Vue();

Vue.config.productionTip = false

window.vueDevMode = process.env.NODE_ENV;
window.serverUrl = location.protocol + '//' + location.host;
window.actionUrl = serverUrl + '/wst/';

if(vueDevMode === "development"){
  window.serverUrl = "http://localhost:8080";
  window.actionUrl = serverUrl + '/wst/';
}

window.videoUrl = serverUrl + '/'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
